module.exports = __webpack_public_path__ + "static/media/list-icon-inactive.2ec8d964.svg";